/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  GameOptionValue: { input: any; output: any; }
};

export type ChannelConnection = {
  __typename?: 'ChannelConnection';
  /** Timestamp when connection was established */
  connectedAt: Scalars['Float']['output'];
  /** Timestamp of last heartbeat */
  lastUpdated: Scalars['Float']['output'];
  /** Socket ID for this connection */
  socketID: Scalars['String']['output'];
  /** User if authenticated, null otherwise */
  user?: Maybe<User>;
};

export type ChannelMetrics = {
  __typename?: 'ChannelMetrics';
  /** Number of authenticated connections */
  authenticatedConnectionCount: Scalars['Int']['output'];
  /** Total number of WebSocket connections */
  connectionCount: Scalars['Int']['output'];
  /** List of active connections */
  connections: Array<ChannelConnection>;
};

export type DeveloperQuery = {
  __typename?: 'DeveloperQuery';
  /** Channel server metrics (developer only) */
  channelMetrics?: Maybe<ChannelMetrics>;
  /** List of all games (developer only) */
  games: GameConnection;
  /** Server environment info (developer only) */
  serverEnv?: Maybe<ServerEnv>;
  /** List of all users (developer only) */
  users: Array<User>;
};


export type DeveloperQueryGamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBots?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Game = {
  __typename?: 'Game';
  /** The current game age */
  age: Scalars['Int']['output'];
  /** The timestamp the game ended */
  endTimestamp?: Maybe<Scalars['Float']['output']>;
  /** The type of game */
  gameType: Scalars['String']['output'];
  /** The unique id of the game */
  id: Scalars['String']['output'];
  /** The current game phase */
  phase: Scalars['String']['output'];
  /** The players in the game */
  players: Array<GamePlayer>;
  /** Rating changes for players in this game */
  ratingDeltas?: Maybe<Array<RatingDelta>>;
  /** The rendered game state as JSON */
  renderedGame: Scalars['String']['output'];
  /** Integer representing the state of the game. Uniquely identifiers game state in an instant in time */
  sequenceID: Scalars['Int']['output'];
  /** The timestamp the game began */
  startTimestamp: Scalars['Float']['output'];
  /** The current game turn */
  turn: Scalars['Int']['output'];
};

export type GameConnection = {
  __typename?: 'GameConnection';
  /** A list of edges. */
  edges: Array<GameEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GameEdge = {
  __typename?: 'GameEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Game>;
};

export type GamePlayer = {
  __typename?: 'GamePlayer';
  /** Game statistics for this player as JSON */
  gameStatsJSON?: Maybe<Scalars['String']['output']>;
  /** The user playing in this game */
  user?: Maybe<User>;
};

export type Lobby = {
  __typename?: 'Lobby';
  /** The date the lobby was created */
  creationDate: Scalars['Float']['output'];
  /** The game associated with this lobby */
  game?: Maybe<Game>;
  /** The user hosting the lobby */
  host: User;
  /** The unique id of the lobby */
  id: Scalars['String']['output'];
  /** The modules enabled for this game. */
  modules: Array<Scalars['String']['output']>;
  /** The name of the lobby. */
  name: Scalars['String']['output'];
  /** The options set for this game. */
  options: Scalars['String']['output'];
  /** Mapping of player IDs to bot types */
  playerIDToBotType: Array<PlayerIdToBotType>;
  /** Players in this lobby */
  players: UserConnection;
  /** Integer representing the state of the lobby, changes each time the lobby changes */
  sequenceID: Scalars['Int']['output'];
  /** Lobby status, e.g. not started, playing, finished */
  status: Scalars['String']['output'];
};


export type LobbyPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LobbyConnection = {
  __typename?: 'LobbyConnection';
  /** A list of edges. */
  edges: Array<LobbyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LobbyEdge = {
  __typename?: 'LobbyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Lobby>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change a user's profile picture */
  changeProfilePicture?: Maybe<User>;
  /** Change a user's name */
  changeUserName?: Maybe<User>;
  /** Add a bot to a lobby */
  lobbyAddBot?: Maybe<Lobby>;
  /** Create a new lobby */
  lobbyCreate?: Maybe<Lobby>;
  /** Join a lobby */
  lobbyJoin?: Maybe<Lobby>;
  /** Remove a player from a lobby */
  lobbyRemovePlayer?: Maybe<Lobby>;
  /** Set a game option in a lobby */
  lobbySetGameOption?: Maybe<Lobby>;
  /** Set a module in a lobby */
  lobbySetModule?: Maybe<Lobby>;
  /** Start a game in a lobby */
  lobbyStartGame?: Maybe<Game>;
  /** Change a user's subtitle */
  tutorialStart?: Maybe<Game>;
};


export type MutationChangeProfilePictureArgs = {
  key: Scalars['String']['input'];
};


export type MutationChangeUserNameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationLobbyAddBotArgs = {
  botName: Scalars['String']['input'];
  lobbyID: Scalars['ID']['input'];
};


export type MutationLobbyJoinArgs = {
  lobbyID: Scalars['ID']['input'];
};


export type MutationLobbyRemovePlayerArgs = {
  lobbyID: Scalars['ID']['input'];
  playerID: Scalars['ID']['input'];
};


export type MutationLobbySetGameOptionArgs = {
  lobbyID: Scalars['ID']['input'];
  option: Scalars['String']['input'];
  value: Scalars['GameOptionValue']['input'];
};


export type MutationLobbySetModuleArgs = {
  enabled: Scalars['Boolean']['input'];
  lobbyID: Scalars['ID']['input'];
  module: Scalars['String']['input'];
};


export type MutationLobbyStartGameArgs = {
  lobbyID: Scalars['ID']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PlayerIdToBotType = {
  __typename?: 'PlayerIDToBotType';
  /** The type of bot the player is */
  botType: Scalars['String']['output'];
  /** The id of the player */
  playerID: Scalars['String']['output'];
};

export type ProfilePicture = {
  __typename?: 'ProfilePicture';
  /** The description of the profile picture */
  description: Scalars['String']['output'];
  /** The key identifier for the profile picture */
  key: Scalars['String']['output'];
  /** The URL to access the profile picture */
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Available profile pictures for the current user */
  availableProfilePictures: Array<ProfilePicture>;
  /** Developer-only queries */
  developer?: Maybe<DeveloperQuery>;
  /** Fetch a game by ID */
  game?: Maybe<Game>;
  /** Leaderboard of users */
  leaderboard: UserConnection;
  /** Fetch a lobby by ID */
  lobby?: Maybe<Lobby>;
  /** List of active lobbies */
  lobby_list: Array<Lobby>;
  /** Fetch a user by ID */
  user?: Maybe<User>;
  /** Fetch multiple users by their IDs */
  users: Array<User>;
  /** The current logged in user */
  viewer?: Maybe<User>;
};


export type QueryGameArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeaderboardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLobbyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type RatingDelta = {
  __typename?: 'RatingDelta';
  /** The player's rating after this game */
  newRating: Scalars['Int']['output'];
  /** The player's rating before this game */
  originalRating: Scalars['Int']['output'];
  /** The player's score in the game */
  score: Scalars['Int']['output'];
  /** The user ID for this rating change */
  userID: Scalars['String']['output'];
};

export type ServerEnv = {
  __typename?: 'ServerEnv';
  /** Channel mode (server-local, server-redis, publisher-redis) */
  channelMode: Scalars['String']['output'];
  /** Channel WebSocket port */
  channelPort: Scalars['String']['output'];
  /** Server hostname */
  hostname: Scalars['String']['output'];
  /** HTTP port */
  httpPort: Scalars['String']['output'];
  /** Node environment (development/production) */
  nodeEnv: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  /** The date the user was created in milliseconds since epoch */
  createdAt: Scalars['Float']['output'];
  /** Games played by this user */
  games?: Maybe<GameConnection>;
  /** The unique id of the user. */
  id: Scalars['ID']['output'];
  /** The name of the user. */
  name: Scalars['String']['output'];
  /** The url of current profile picture of the user. */
  profilePictureURL: Scalars['String']['output'];
  /** The url of the user's profile page */
  profileURL?: Maybe<Scalars['String']['output']>;
  /** User game statistics */
  stats?: Maybe<UserStats>;
  /** The raw JSON of the stats */
  statsJSON?: Maybe<Scalars['String']['output']>;
  /** The subtitle of the user. */
  subtitle: Scalars['String']['output'];
};


export type UserGamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<User>;
};

export type UserStats = {
  __typename?: 'UserStats';
  /** The rating of the user */
  rating?: Maybe<Scalars['Float']['output']>;
  /** The total blame time of all games this user has been in */
  totalBlameMillis: Scalars['Int']['output'];
  /** The number of games the user has played. */
  totalGames: Scalars['Int']['output'];
  /** The number of games the user has won. */
  totalWins: Scalars['Int']['output'];
};

export type AdminMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMetricsQuery = { __typename?: 'Query', developer?: { __typename?: 'DeveloperQuery', channelMetrics?: { __typename?: 'ChannelMetrics', connectionCount: number, authenticatedConnectionCount: number, connections: Array<{ __typename?: 'ChannelConnection', socketID: string, connectedAt: number, lastUpdated: number, user?: { __typename?: 'User', id: string, name: string } | null }> } | null, serverEnv?: { __typename?: 'ServerEnv', hostname: string, nodeEnv: string, httpPort: string, channelPort: string, channelMode: string } | null } | null };

export type GameHistoryListQueryVariables = Exact<{
  includeBots?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GameHistoryListQuery = { __typename?: 'Query', developer?: { __typename?: 'DeveloperQuery', games: { __typename?: 'GameConnection', edges: Array<{ __typename?: 'GameEdge', node?: { __typename?: 'Game', id: string, startTimestamp: number, endTimestamp?: number | null, age: number, players: Array<{ __typename?: 'GamePlayer', user?: { __typename?: 'User', id: string, name: string } | null }>, ratingDeltas?: Array<{ __typename?: 'RatingDelta', userID: string, score: number, originalRating: number, newRating: number }> | null } | null }> } } | null };

export type UserSummaryFragment = { __typename?: 'User', id: string, createdAt: number, name: string, profilePictureURL: string, profileURL?: string | null, subtitle: string, stats?: { __typename?: 'UserStats', rating?: number | null, totalGames: number, totalWins: number, totalBlameMillis: number } | null } & { ' $fragmentName'?: 'UserSummaryFragment' };

export type GetLobbyListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLobbyListQuery = { __typename?: 'Query', lobby_list: Array<{ __typename?: 'Lobby', id: string, name: string, creationDate: number, status: string, host: (
      { __typename?: 'User' }
      & { ' $fragmentRefs'?: { 'UserSummaryFragment': UserSummaryFragment } }
    ), game?: { __typename?: 'Game', id: string, endTimestamp?: number | null } | null, players: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node?: (
          { __typename?: 'User' }
          & { ' $fragmentRefs'?: { 'UserSummaryFragment': UserSummaryFragment } }
        ) | null }> } }> };

export type GetLobbyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLobbyQuery = { __typename?: 'Query', lobby?: { __typename?: 'Lobby', id: string, sequenceID: number, name: string, options: string, modules: Array<string>, host: (
      { __typename?: 'User' }
      & { ' $fragmentRefs'?: { 'UserSummaryFragment': UserSummaryFragment } }
    ), players: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node?: (
          { __typename?: 'User' }
          & { ' $fragmentRefs'?: { 'UserSummaryFragment': UserSummaryFragment } }
        ) | null }> }, playerIDToBotType: Array<{ __typename?: 'PlayerIDToBotType', playerID: string, botType: string }>, game?: { __typename?: 'Game', id: string } | null } | null };

export type UsersQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<(
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'UserSummaryFragment': UserSummaryFragment } }
  )> };

export type LeaderboardQueryVariables = Exact<{ [key: string]: never; }>;


export type LeaderboardQuery = { __typename?: 'Query', leaderboard: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node?: (
        { __typename?: 'User' }
        & { ' $fragmentRefs'?: { 'UserSummaryFragment': UserSummaryFragment } }
      ) | null }> } };

export type CreateLobbyMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateLobbyMutation = { __typename?: 'Mutation', lobbyCreate?: { __typename?: 'Lobby', id: string } | null };

export type TutorialStartMutationVariables = Exact<{ [key: string]: never; }>;


export type TutorialStartMutation = { __typename?: 'Mutation', tutorialStart?: { __typename?: 'Game', id: string } | null };

export type AddBotMutationVariables = Exact<{
  lobbyID: Scalars['ID']['input'];
  botName: Scalars['String']['input'];
}>;


export type AddBotMutation = { __typename?: 'Mutation', lobbyAddBot?: { __typename?: 'Lobby', sequenceID: number } | null };

export type RemovePlayerMutationVariables = Exact<{
  lobbyID: Scalars['ID']['input'];
  playerID: Scalars['ID']['input'];
}>;


export type RemovePlayerMutation = { __typename?: 'Mutation', lobbyRemovePlayer?: { __typename?: 'Lobby', sequenceID: number } | null };

export type StartGameMutationVariables = Exact<{
  lobbyID: Scalars['ID']['input'];
}>;


export type StartGameMutation = { __typename?: 'Mutation', lobbyStartGame?: { __typename?: 'Game', id: string, sequenceID: number } | null };

export type SetGameOptionMutationVariables = Exact<{
  lobbyID: Scalars['ID']['input'];
  option: Scalars['String']['input'];
  value: Scalars['GameOptionValue']['input'];
}>;


export type SetGameOptionMutation = { __typename?: 'Mutation', lobbySetGameOption?: { __typename?: 'Lobby', sequenceID: number } | null };

export type SetModuleMutationVariables = Exact<{
  lobbyID: Scalars['ID']['input'];
  module: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetModuleMutation = { __typename?: 'Mutation', lobbySetModule?: { __typename?: 'Lobby', sequenceID: number } | null };

export type JoinLobbyMutationVariables = Exact<{
  lobbyID: Scalars['ID']['input'];
}>;


export type JoinLobbyMutation = { __typename?: 'Mutation', lobbyJoin?: { __typename?: 'Lobby', sequenceID: number } | null };

export type DevUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type DevUserListQuery = { __typename?: 'Query', developer?: { __typename?: 'DeveloperQuery', users: Array<(
      { __typename?: 'User' }
      & { ' $fragmentRefs'?: { 'UserSummaryFragment': UserSummaryFragment } }
    )> } | null };

export type AvailableProfilePicturesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableProfilePicturesQuery = { __typename?: 'Query', availableProfilePictures: Array<{ __typename?: 'ProfilePicture', key: string, url: string, description: string }> };

export type ChangeUserNameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type ChangeUserNameMutation = { __typename?: 'Mutation', changeUserName?: { __typename?: 'User', id: string } | null };

export type ChangeProfilePictureMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type ChangeProfilePictureMutation = { __typename?: 'Mutation', changeProfilePicture?: { __typename?: 'User', id: string } | null };

export type GetUserProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserProfileQuery = { __typename?: 'Query', user?: (
    { __typename?: 'User', statsJSON?: string | null, games?: { __typename?: 'GameConnection', edges: Array<{ __typename?: 'GameEdge', node?: (
          { __typename?: 'Game', renderedGame: string }
          & { ' $fragmentRefs'?: { 'GameSummaryFragment': GameSummaryFragment } }
        ) | null }> } | null }
    & { ' $fragmentRefs'?: { 'UserSummaryFragment': UserSummaryFragment } }
  ) | null };

export type GameSummaryFragment = { __typename?: 'Game', id: string, startTimestamp: number, endTimestamp?: number | null, players: Array<{ __typename?: 'GamePlayer', gameStatsJSON?: string | null, user?: (
      { __typename?: 'User' }
      & { ' $fragmentRefs'?: { 'UserSummaryFragment': UserSummaryFragment } }
    ) | null }>, ratingDeltas?: Array<{ __typename?: 'RatingDelta', userID: string, score: number, originalRating: number, newRating: number }> | null } & { ' $fragmentName'?: 'GameSummaryFragment' };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const UserSummaryFragmentDoc = new TypedDocumentString(`
    fragment UserSummary on User {
  id
  createdAt
  name
  profilePictureURL
  profileURL
  subtitle
  stats {
    rating
    totalGames
    totalWins
    totalBlameMillis
  }
}
    `, {"fragmentName":"UserSummary"}) as unknown as TypedDocumentString<UserSummaryFragment, unknown>;
export const GameSummaryFragmentDoc = new TypedDocumentString(`
    fragment GameSummary on Game {
  id
  startTimestamp
  endTimestamp
  players {
    user {
      ...UserSummary
    }
    gameStatsJSON
  }
  ratingDeltas {
    userID
    score
    originalRating
    newRating
  }
}
    fragment UserSummary on User {
  id
  createdAt
  name
  profilePictureURL
  profileURL
  subtitle
  stats {
    rating
    totalGames
    totalWins
    totalBlameMillis
  }
}`, {"fragmentName":"GameSummary"}) as unknown as TypedDocumentString<GameSummaryFragment, unknown>;
export const AdminMetricsDocument = new TypedDocumentString(`
    query AdminMetrics {
  developer {
    channelMetrics {
      connectionCount
      authenticatedConnectionCount
      connections {
        socketID
        user {
          id
          name
        }
        connectedAt
        lastUpdated
      }
    }
    serverEnv {
      hostname
      nodeEnv
      httpPort
      channelPort
      channelMode
    }
  }
}
    `) as unknown as TypedDocumentString<AdminMetricsQuery, AdminMetricsQueryVariables>;
export const GameHistoryListDocument = new TypedDocumentString(`
    query GameHistoryList($includeBots: Boolean) {
  developer {
    games(includeBots: $includeBots) {
      edges {
        node {
          id
          startTimestamp
          endTimestamp
          age
          players {
            user {
              id
              name
            }
          }
          ratingDeltas {
            userID
            score
            originalRating
            newRating
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GameHistoryListQuery, GameHistoryListQueryVariables>;
export const GetLobbyListDocument = new TypedDocumentString(`
    query getLobbyList {
  lobby_list {
    id
    name
    host {
      ...UserSummary
    }
    creationDate
    status
    game {
      id
      endTimestamp
    }
    players {
      edges {
        node {
          ...UserSummary
        }
      }
    }
  }
}
    fragment UserSummary on User {
  id
  createdAt
  name
  profilePictureURL
  profileURL
  subtitle
  stats {
    rating
    totalGames
    totalWins
    totalBlameMillis
  }
}`) as unknown as TypedDocumentString<GetLobbyListQuery, GetLobbyListQueryVariables>;
export const GetLobbyDocument = new TypedDocumentString(`
    query getLobby($id: ID!) {
  lobby(id: $id) {
    id
    sequenceID
    name
    options
    modules
    host {
      ...UserSummary
    }
    players {
      edges {
        node {
          ...UserSummary
        }
      }
    }
    playerIDToBotType {
      playerID
      botType
    }
    game {
      id
    }
  }
}
    fragment UserSummary on User {
  id
  createdAt
  name
  profilePictureURL
  profileURL
  subtitle
  stats {
    rating
    totalGames
    totalWins
    totalBlameMillis
  }
}`) as unknown as TypedDocumentString<GetLobbyQuery, GetLobbyQueryVariables>;
export const UsersDocument = new TypedDocumentString(`
    query Users($ids: [ID!]!) {
  users(ids: $ids) {
    ...UserSummary
  }
}
    fragment UserSummary on User {
  id
  createdAt
  name
  profilePictureURL
  profileURL
  subtitle
  stats {
    rating
    totalGames
    totalWins
    totalBlameMillis
  }
}`) as unknown as TypedDocumentString<UsersQuery, UsersQueryVariables>;
export const LeaderboardDocument = new TypedDocumentString(`
    query Leaderboard {
  leaderboard {
    edges {
      node {
        ...UserSummary
      }
    }
  }
}
    fragment UserSummary on User {
  id
  createdAt
  name
  profilePictureURL
  profileURL
  subtitle
  stats {
    rating
    totalGames
    totalWins
    totalBlameMillis
  }
}`) as unknown as TypedDocumentString<LeaderboardQuery, LeaderboardQueryVariables>;
export const CreateLobbyDocument = new TypedDocumentString(`
    mutation CreateLobby {
  lobbyCreate {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateLobbyMutation, CreateLobbyMutationVariables>;
export const TutorialStartDocument = new TypedDocumentString(`
    mutation TutorialStart {
  tutorialStart {
    id
  }
}
    `) as unknown as TypedDocumentString<TutorialStartMutation, TutorialStartMutationVariables>;
export const AddBotDocument = new TypedDocumentString(`
    mutation AddBot($lobbyID: ID!, $botName: String!) {
  lobbyAddBot(lobbyID: $lobbyID, botName: $botName) {
    sequenceID
  }
}
    `) as unknown as TypedDocumentString<AddBotMutation, AddBotMutationVariables>;
export const RemovePlayerDocument = new TypedDocumentString(`
    mutation RemovePlayer($lobbyID: ID!, $playerID: ID!) {
  lobbyRemovePlayer(lobbyID: $lobbyID, playerID: $playerID) {
    sequenceID
  }
}
    `) as unknown as TypedDocumentString<RemovePlayerMutation, RemovePlayerMutationVariables>;
export const StartGameDocument = new TypedDocumentString(`
    mutation StartGame($lobbyID: ID!) {
  lobbyStartGame(lobbyID: $lobbyID) {
    id
    sequenceID
  }
}
    `) as unknown as TypedDocumentString<StartGameMutation, StartGameMutationVariables>;
export const SetGameOptionDocument = new TypedDocumentString(`
    mutation SetGameOption($lobbyID: ID!, $option: String!, $value: GameOptionValue!) {
  lobbySetGameOption(lobbyID: $lobbyID, option: $option, value: $value) {
    sequenceID
  }
}
    `) as unknown as TypedDocumentString<SetGameOptionMutation, SetGameOptionMutationVariables>;
export const SetModuleDocument = new TypedDocumentString(`
    mutation SetModule($lobbyID: ID!, $module: String!, $enabled: Boolean!) {
  lobbySetModule(lobbyID: $lobbyID, module: $module, enabled: $enabled) {
    sequenceID
  }
}
    `) as unknown as TypedDocumentString<SetModuleMutation, SetModuleMutationVariables>;
export const JoinLobbyDocument = new TypedDocumentString(`
    mutation JoinLobby($lobbyID: ID!) {
  lobbyJoin(lobbyID: $lobbyID) {
    sequenceID
  }
}
    `) as unknown as TypedDocumentString<JoinLobbyMutation, JoinLobbyMutationVariables>;
export const DevUserListDocument = new TypedDocumentString(`
    query DevUserList {
  developer {
    users {
      ...UserSummary
    }
  }
}
    fragment UserSummary on User {
  id
  createdAt
  name
  profilePictureURL
  profileURL
  subtitle
  stats {
    rating
    totalGames
    totalWins
    totalBlameMillis
  }
}`) as unknown as TypedDocumentString<DevUserListQuery, DevUserListQueryVariables>;
export const AvailableProfilePicturesDocument = new TypedDocumentString(`
    query AvailableProfilePictures {
  availableProfilePictures {
    key
    url
    description
  }
}
    `) as unknown as TypedDocumentString<AvailableProfilePicturesQuery, AvailableProfilePicturesQueryVariables>;
export const ChangeUserNameDocument = new TypedDocumentString(`
    mutation ChangeUserName($id: ID!, $name: String!) {
  changeUserName(id: $id, name: $name) {
    id
  }
}
    `) as unknown as TypedDocumentString<ChangeUserNameMutation, ChangeUserNameMutationVariables>;
export const ChangeProfilePictureDocument = new TypedDocumentString(`
    mutation ChangeProfilePicture($key: String!) {
  changeProfilePicture(key: $key) {
    id
  }
}
    `) as unknown as TypedDocumentString<ChangeProfilePictureMutation, ChangeProfilePictureMutationVariables>;
export const GetUserProfileDocument = new TypedDocumentString(`
    query getUserProfile($id: ID!) {
  user(id: $id) {
    ...UserSummary
    statsJSON
    games(first: 5) {
      edges {
        node {
          ...GameSummary
          renderedGame
        }
      }
    }
  }
}
    fragment UserSummary on User {
  id
  createdAt
  name
  profilePictureURL
  profileURL
  subtitle
  stats {
    rating
    totalGames
    totalWins
    totalBlameMillis
  }
}
fragment GameSummary on Game {
  id
  startTimestamp
  endTimestamp
  players {
    user {
      ...UserSummary
    }
    gameStatsJSON
  }
  ratingDeltas {
    userID
    score
    originalRating
    newRating
  }
}`) as unknown as TypedDocumentString<GetUserProfileQuery, GetUserProfileQueryVariables>;